/**
 * Init Subscribe Button
 */
const initSubscribeButton = () => {
	$('.js-subscribe').on('click', '.btn--subscribe', function (event) {
		const $this = $(this);
		const $parent = $this.closest('.js-subscribe');

		$parent.toggleClass('is-open');

		event.preventDefault();
	});
};

initSubscribeButton();
